const url = process.env.NEXT_PUBLIC_SUPABASE_URL
const key = process.env.NEXT_PUBLIC_SUPABASE_KEY

if (!url) throw new Error('Missing Supabase url')
if (!key) throw new Error('Missing Supabase key')

export { url, key }
